import { HelpCardProps } from "@/components/screen/global-components/help/HelpCard";

export const FAQHelpCards: HelpCardProps[] = [
  {
    title: "Plans and pricing",
    iconId: "icon-dollar_48",
  },
  {
    title: "Speed and turnaround",
    iconId: "icon-clock-circle_48",
  },
  {
    title: "How it works",
    iconId: "icon-document_48",
  },
  {
    title: "Quality and accuracy",
    iconId: "icon-start_48",
  },
  {
    title: "Existing clients and orders",
    iconId: "icon-clipboard-list_48",
  },
  {
    title: "Certified and notarized Translations",
    iconId: "icon-medal-ribbon_48",
  },
  {
    title: "Languages",
    iconId: "icon-language_48",
  },
  {
    title: "Deliverables and documents",
    iconId: "icon-document-add_48",
  },
  {
    title: "Formatting and design",
    iconId: "icon-password-minimalistic-input_48",
  },
  {
    title: "Immigration and USCIS",
    iconId: "icon-uscis_146",
    iconSizes: {
      width: 146,
      height: 50,
    },
  },
  {
    title: "Tips and best practices",
    iconId: "icon-bookmark_48",
  },
  {
    title: "Machine translations",
    iconId: "icon-bolt_48",
  },
];
